// WordPress dependencies.
import { registerBlockStyle, registerBlockVariation } from '@wordpress/blocks';
import domReady from '@wordpress/dom-ready';
import { __ } from '@wordpress/i18n';

domReady( () => {
	registerBlockStyle( 'core/heading', [
		{
			name: 'default',
			label: __( 'Default', 'theme-slug' ),
			isDefault: true,
		},
		{
			name: 'primary',
			label: __( 'Primary', 'theme-slug' ),
		},
		{
			name: 'secondary',
			label: __( 'Secondary', 'theme-slug' ),
		},
	] );

	registerBlockStyle( 'core/button', [
		{
			name: 'outline-primary',
			label: __( 'Outline Primary', 'theme-slug' ),
		},
		{
			name: 'outline-secondary',
			label: __( 'Outline Secondary', 'theme-slug' ),
		},
		{
			name: 'outline-light',
			label: __( 'Outline Light', 'theme-slug' ),
		},
		{
			name: 'outline-dark',
			label: __( 'Outline Dark', 'theme-slug' ),
		},
	] );

	registerBlockVariation( 'core/heading', {
		name: 'jumbo',
		title: 'Jumbo Heading',
		attributes: {
			fontSize: 'max-72',
		},
		isActive: [ 'fontSize' ],
	} );
} );
